import { combineReducers } from '@reduxjs/toolkit';

import { definitionSlice, reportSlice, sourceSlice } from './slices';

export const reportsReducer = combineReducers({
  definition: definitionSlice,
  report: reportSlice,
  source: sourceSlice,
});
